//import { ReactComponent as Trash } from 'assets/icons/trash.svg';
//import { ReactComponent as TrendUp } from 'assets/icons/trend-up.svg';
import { ReactElement } from 'react';

import { CardActions } from 'constants/enums';

import { ReactComponent as Calendar } from 'assets/icons/calendar.svg';
import { ReactComponent as CloseSquare } from 'assets/icons/closeSquare.svg';
// import { ReactComponent as EditIcon } from 'assets/icons/edit-square.svg';
import { ReactComponent as Eye } from 'assets/icons/eye.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
//import { ReactComponent as Receipt } from 'assets/icons/receipt.svg';
import { ReactComponent as Send } from 'assets/icons/send.svg';
import { ReactComponent as InviteIcon } from 'assets/icons/sms-tracking.svg';
import { ReactComponent as TickSquare } from 'assets/icons/tickSquare.svg';

import { TranslationKey } from '../../types/i18next';
import styles from './SelectCardWrapper.module.scss';

export const cardActionsConfig: {
  label: TranslationKey;
  value: CardActions;
  icon: ReactElement;
  className: string;
}[] = [
  // {
  //   label: 'cardActions.label.edit',
  //   value: CardActions.JobEdit,
  //   icon: <EditIcon />,
  //   className: styles.gray
  // },
  // {
  //   label: 'Pay',
  //   value: CardActions.JobPay,
  //   icon: <Receipt />,
  //   className: styles.gray
  // },
  // {
  //   label: 'cardActions.label.upgrade',
  //   value: CardActions.JobUpgrade,
  //   icon: <TrendUp />,
  //   className: styles.gray
  // },
  {
    label: 'cardActions.label.view',
    value: CardActions.JobView,
    icon: <Eye />,
    className: styles.gray
  },
  // {
  //   label: 'cardActions.label.delete',
  //   value: CardActions.JobDelete,
  //   icon: <Trash />,
  //   className: styles.red
  // },
  {
    label: 'cardActions.label.unsubscribe',
    value: CardActions.JobCancelSubscription,
    icon: <CloseSquare />,
    className: styles.gray
  },
  {
    label: 'cardActions.label.reopen',
    value: CardActions.JobReactivate,
    icon: <TickSquare />,
    className: styles.green
  },
  {
    label: 'cardActions.label.accept',
    value: CardActions.ApplicationAccept,
    icon: <TickSquare />,
    className: styles.green
  },
  {
    label: 'cardActions.label.sendOffer',
    value: CardActions.ApplicationSendOffer,
    icon: <Send />,
    className: styles.gray
  },
  {
    label: 'cardActions.label.scheduleInterview',
    value: CardActions.ApplicationScheduleInterview,
    icon: <Calendar />,
    className: styles.gray
  },
  {
    label: 'cardActions.label.reject',
    value: CardActions.ApplicationReject,
    icon: <CloseSquare />,
    className: styles.red
  },
  {
    label: 'cardActions.label.inviteToJob',
    value: CardActions.JobseekerInviteToJob,
    icon: <PlusIcon />,
    className: styles.gray
  }
];
